<template>
  <div class="juou-card">
    <JuouProTable
      ref="tableRef"
      title="黑名单管理"
      :paginations="{ pageSize: 10 }"
      :columns="columns"
      :get-data="getData"
      :on-add="addBlacklist"
      :on-edit="updateBlacklist"
      :on-delete="deleteBlacklist"
      :loading="loading"
      :is-dangder-delete="true"
      :format-dangder-delete-info="formatDeleteInfo"
      row-key="id"
      :add-init-values="addInitValue"
      :codition-init-values="conditionsInitValue"
    />
  </div>
</template>

<script lang="ts" setup>
import {
  JuouProTable,
  JuouProTableColumn,
  JuouProTableData,
  JuouProTableFilter,
  JuouProTableGetDataFunction,
  useBaseAsync,
} from 'juou-managebase-ui';
import { ElMessage } from 'element-plus';
import { ref, watchEffect } from 'vue';
import dayjs from 'dayjs';
import { useApi } from '@/hooks/useApi';
import type { BlacklistAdminVo } from '@/api';

const columns = ref<JuouProTableColumn[]>([]);
const tableRef = ref<InstanceType<typeof JuouProTable>>();
const loading = ref(false);
type BlacklistRow = BlacklistAdminVo & { id: number };

const addInitValue = {};
const conditionsInitValue = {};

const init = useBaseAsync(() => {
  columns.value = [
    {
      name: 'phone',
      label: '手机号',
      type: 'numberStr',
      isCondition: true,
      rule: [{ required: true, message: '请输入手机号' }],
    },
    {
      name: 'remark',
      label: '备注',
      type: 'string',
      isCondition: true,
    },
    {
      name: 'createTime',
      label: '创建时间',
      type: 'string',
      hideCreate: true,
      hideEdit: true,
      width: 165,
      render: ({ row }: { row: BlacklistRow }) => (row.createTime ? dayjs(row.createTime).format('YYYY-MM-DD HH:mm:ss') : '-'),
    },
    {
      name: 'updateTime',
      label: '更新时间',
      type: 'string',
      hideCreate: true,
      hideEdit: true,
      width: 165,
      render: ({ row }: { row: BlacklistRow }) => (row.updateTime ? dayjs(row.updateTime).format('YYYY-MM-DD HH:mm:ss') : '-'),
    },
  ];
});

const getData = useBaseAsync<JuouProTableGetDataFunction>(async(filter: JuouProTableFilter) => {
  try {
    loading.value = true;
    const conditions = Object.entries(filter.conditions).reduce((result, [key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        result[key] = value;
      }
      return result;
    }, {} as Record<string, unknown>);
    const res = await useApi().blacklistApi.pageBlacklistBlacklist({
      conditions: conditions as Partial<BlacklistAdminVo>,
      pageQuery: {
        page: filter.paginations.page - 1,
        pageSize: filter.paginations.pageSize,
      },
    });
    return {
      total: res.data.data?.total || 0,
      data: res.data.data?.data || [],
    } as JuouProTableData;
  } finally {
    loading.value = false;
  }
});

const addBlacklist = useBaseAsync(async(data: BlacklistAdminVo) => {
  await useApi().blacklistApi.addBlacklistBlacklist(data);
  ElMessage.success('已加入黑名单');
});

const updateBlacklist = useBaseAsync(async(data: BlacklistRow) => {
  await useApi().blacklistApi.updateBlacklistBlacklist(data);
  ElMessage.success('修改成功');
});

const deleteBlacklist = useBaseAsync(async(data: BlacklistRow) => {
  await useApi().blacklistApi.deleteBlacklistBlacklist(data.id);
  ElMessage.success('已移出黑名单');
});

const formatDeleteInfo = (row: BlacklistRow) => `您正在将手机号 ${row.phone} 移出黑名单，请谨慎操作`;

init();

watchEffect(() => {
  tableRef.value?.refresh();
});
</script>

<style lang="scss" scoped>
</style>
